/**
 * Created by claude on 22.07.26.
 * Scene component extracted from Merge2Scene
 */

class Merge2SceneComponent extends ScriptComponent {
    onCreate() {
        this.styles = PrefabBuilder.resolveProperty(this.options.styles, this.context);
        this.styles.hint.font = PrefabBuilder.resolveFont(this.styles.hint.font, this.context);
    }

    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);
        this.sceneComponent.setBundles(this.listBundles());
        this.sceneComponent.setAudioStyles(this.getAudioStyles());
    }

    onBeforeSceneLoaded() {
        this.game = new Merge2();
    }

    startsWithTutorial() {
        const tutorial = cleverapps.tutorial.findScenario(TutorialScenario.BASIC_TUTORIAL_NAME);
        return Boolean(tutorial && tutorial.isAvailable());
    }

    onSceneLoaded() {
        if (this.startsWithTutorial() || cleverapps.dataVersion.useSingleLocationMigrationNotice || this.game.location.openInMetaMode) {
            delete this.game.location.openInMetaMode;
            Merge2.current.changeMode(Merge2.MODE_META, () => {});
        }
        this.hintViews = [
            new MergeHintView(),
            new GeneratorHintView(),
            new OrderHintView(),
            new RepairHintView(),
            new BubblesStackHintView(),
            new CupHintView(),
            new CollectibleHintView(),
            new BackpackHintView(),
            new RemoveHintView()
        ];

        new BoardFullHelper(CollectibleLastStageHintLogic);
        new BoardFullHelper(CollectibleHintLogic);
        new BoardFullHelper(BackpackHintLogic);
        new BoardFullHelper(RemoveHintLogic);
    }

    scrollOrdersToRow(rowId) {
        if (this.ordersScrolling) {
            return;
        }

        this.ordersScrolling = true;
        cleverapps.availableMove.pause("ordersScroll");

        this.ordersTable.scrollToRow(rowId, () => {
            this.ordersScrolling = false;
            cleverapps.availableMove.resume("ordersScroll");
        });
    }

    buildRoomView() {
        const location = cleverapps.meta.getSelectedLocation();
        const ViewClass = location.getViewClass();

        this.roomView = new ViewClass(location);
        return this.roomView;
    }

    buildOrdersTableModel() {
        this.ordersTable = new ScrollTable(this.game.ordersDataSource, {
            scrollDisabled: true,
            parentView: this.node,
            direction: cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? cleverapps.UI.HORIZONTAL : cleverapps.UI.VERTICAL
        });

        return this.ordersTable;
    }

    getOrdersRowConstructor() {
        return CustomerRecipeIconView;
    }

    getOrdersTableStyles() {
        return this.styles.ordersTable.tableStyles;
    }

    hasExtraBar() {
        return !cleverapps.gameModes.noSidebar && !cleverapps.config.demoMode;
    }

    buildExtraBarModel() {
        this.extraBarTable = new ScrollTable(new ExtraBarIconsDataSource(), {
            direction: cleverapps.UI.HORIZONTAL,
            scrollDisabled: true
        });

        return this.extraBarTable;
    }

    getExtraBarRowConstructor() {
        return ExtraBarIconView;
    }

    getExtraBarAnimations() {
        return ExtraBarIconAnimations;
    }

    getExtraBarStyles() {
        return this.styles.extraBar;
    }

    buildFieldView() {
        this.map = new FlatFieldView(this.game.field);
        return this.map;
    }

    hasGameBackground() {
        return !!this.styles.gameBackground;
    }

    buildGameBackground() {
        this.gameBackground = new cc.Sprite(this.getBackgroundFrame());
        return this.gameBackground;
    }

    hasOrangery() {
        return !!(Merge2.current.field.orangery && !cleverapps.gameModes.noControls);
    }

    buildOrangery() {
        this.orangeryView = new OrangeryView(Merge2.current.field.orangery);
        return this.orangeryView;
    }

    getOrangeryControlName() {
        return Merge2.current.field.orangery.getControlName();
    }

    buildSwitchButton() {
        this.switchButton = new SwitchButton();
        return this.switchButton;
    }

    hasProgressView() {
        return typeof RepairProgressView !== "undefined";
    }

    buildProgressView() {
        this.progressView = new RepairProgressView();
        return this.progressView;
    }

    buildBackpackButton() {
        this.backpackButton = new BackpackButton();
        return this.backpackButton;
    }

    onReady() {
        const location = cleverapps.meta.getSelectedLocation();

        this.ordersTableViewControl = ComponentUtils.findChildByName(this.node, "ordersTableControl");
        this.ordersTableHiding = ComponentMap.get(this.ordersTableViewControl, HidingComponent);
        this.ordersTableView = this.ordersTableHiding.target;

        this.scrollLines = this.ordersTableViewControl.children.filter((line) => line !== this.ordersTableView);
        this.toggleScrollLines();

        this.extraBarControl = ComponentUtils.findChildByName(this.node, "extraBarControl");
        if (this.extraBarControl) {
            this.extraBarHiding = ComponentMap.get(this.extraBarControl, HidingComponent);
            this.extraBarView = this.extraBarHiding.target;
        }

        this.unitInfoControl = ComponentUtils.findChildByName(this.node, "unitInfoControl");
        this.unitInfoHiding = ComponentMap.get(this.unitInfoControl, HidingComponent);
        this.unitInfoView = this.unitInfoHiding.target;

        this.mapControl = this.map.getParent();
        this.mapHiding = ComponentMap.get(this.mapControl, HidingComponent);

        this.fieldWrapper = ComponentUtils.findChildByName(this.node, "fieldWrapper");

        this.backpackControl = this.backpackButton.getParent();
        this.switchControl = this.switchButton.getParent();
        if (!this.startsWithTutorial()) {
            this.showSwitchButton(true);
        }
        this.bottomLayout = ComponentUtils.findChildByName(this.node, "bottomLayout");

        if (!Merge2.current.backpack.isAvailable()) {
            this.backpackButton.hide();
        }

        this.game.on("showHint", this.showHint.bind(this), this.node);

        Merge2.current.on("changeMode", this.onChangeMode.bind(this), this.node);

        location.on("nextStage", this.updateExtraBar.bind(this), this.node);
        location.on("taskWindowShown", this.onTaskWindowShown.bind(this), this.node);
        location.on("taskWindowHidden", this.onTaskWindowHidden.bind(this), this.node);
        cleverapps.weeklyGoals.on("updateGoals", this.updateExtraBar.bind(this), this.node);

        this.onChangeMode(true);

        this.resolutionMode = cleverapps.resolution.mode;
        cleverapps.config.debugMode && Merge2StatInfo.toggleInfo();

        this.onResize();
    }

    onTaskWindowShown() {
        if (this.roomView.repairViewHiding) {
            this.roomView.repairViewHiding.hide();
        }
    }

    onTaskWindowHidden() {
        if (Merge2.current.mode !== Merge2.MODE_META) {
            return;
        }

        if (this.roomView.repairViewHiding) {
            this.roomView.repairViewHiding.show();
        }

        if (this.progressView) {
            this.progressView.onChangeStage();
        }
    }

    toggleScrollLines() {
        this.scrollLines.forEach((scrollLine) => {
            scrollLine.setVisible(cleverapps.resolution.mode !== cleverapps.WideMode.VERTICAL && Merge2.current.mode === Merge2.MODE_GAME);
        });
    }

    onChangeMode(silent) {
        const mode = Merge2.current.mode;
        cleverapps.audio.fadeOut(0.2);
        this.sceneComponent.startOrRestartMusic(this.getAudioStyles());

        if (mode === Merge2.MODE_META) {
            cleverapps.focusManager.setHiddenByDefault("backpackButton", [cleverapps.Environment.SCENE_MAIN]);
            cleverapps.focusManager.setHiddenByDefault("toolbar", []);
            // shown silently first, so the visibility update that follows has nothing left to animate
            cleverapps.focusManager.showControlsWhileFocused("repairProgress", true);
            cleverapps.focusManager.setHiddenByDefault("repairProgress", []);
            this.setSideBarHiddenByDefault([]);

            this.mapHiding.hide(silent);
            this.ordersTableHiding.hide(silent);
            this.unitInfoHiding.hide(silent);
            this.ordersTable.stop();
            if (this.extraBarHiding) {
                this.extraBarHiding.hide(silent);
            }

            cleverapps.effects.fire("merge2.scene.down");
        } else {
            cleverapps.focusManager.setHiddenByDefault("backpackButton", []);
            cleverapps.focusManager.setHiddenByDefault("toolbar", [cleverapps.Environment.SCENE_MAIN]);
            cleverapps.focusManager.setHiddenByDefault("repairProgress", [cleverapps.Environment.SCENE_MAIN]);

            this.setSideBarHiddenByDefault([cleverapps.Environment.SCENE_MAIN]);

            this.mapHiding.show(silent);
            this.ordersTableHiding.show(silent);
            this.unitInfoHiding.show(silent);
            if (this.extraBarHiding) {
                this.extraBarHiding.show(silent);
            }

            cleverapps.effects.fire("merge2.scene.show");
        }

        this.toggleScrollLines();

        ComponentUtils.findComponentByName(this.node, "UpMenuController").refreshControls();

        this.updateRoomBorders();

        if (mode === Merge2.MODE_META) {
            this.roomView.show(silent);
        } else {
            this.roomView.hide(silent);
        }

        this.updateLayout();
        this.gameBackground && this.updateBackground();

        if (connector.platform.oneOf(connector.CRAZY)) {
            if (this.game.mode === Merge2.MODE_META && !this.metaGameplayStart) {
                connector.platform.gameplayStop();
                this.metaGameplayStart = cleverapps.once(() => connector.platform.gameplayStart());
                this.node.addCleaner(this.metaGameplayStart);
            } else if (this.game.mode !== Merge2.MODE_META && this.metaGameplayStart) {
                this.metaGameplayStart();
                this.metaGameplayStart = undefined;
            }
        }

        if (!this.gameplayStarted && this.game.mode === Merge2.MODE_GAME
            && (cleverapps.gameLevel.withOwnLevel() || cleverapps.meta.getSelectedLocation().locationConfig.isMain)) {
            this.gameplayStarted = true;
            connector.platform.gameplayStart(cleverapps.gameLevel.getLevel());
        }
    }

    updateLayout() {
        if (this.game.mode === Merge2.MODE_META) {
            this.layoutSwitchButtonMeta();
        } else if (cleverapps.resolution.isVertical()) {
            this.layoutBottomRow();
        } else {
            this.layoutFieldWrapper();
        }
    }

    moveControl(control, parent) {
        if (control.getParent() !== parent) {
            ComponentMap.detach(control, AlignmentComponent);
            control.replaceParent(parent);
        }
    }

    showSwitchButton(silent) {
        ComponentMap.get(this.switchControl, HidingComponent).show(silent);
    }

    layoutSwitchButtonMeta() {
        const button = this.switchControl;
        const styles = this.styles.switchButtonMeta;

        this.moveControl(button, this.node);
        button.setScale(cleverapps.resolution.isVertical() ? styles.verticalScale : 1);
        button.setAlignment(styles.position[cleverapps.resolution.mode]);
    }

    layoutBottomRow() {
        const layout = this.bottomLayout;
        const unitInfo = this.unitInfoControl;
        const button = this.switchControl;

        this.moveControl(unitInfo, layout);
        this.moveControl(button, layout);

        unitInfo.setScale(1);
        button.setScale(this.styles.bottomLayout.verticalScale);
        if (this.backpackControl) {
            this.backpackControl.setScale(this.styles.bottomLayout.verticalScale);
        }

        layout.reshape();
        layout.setScale(Math.min(1, cleverapps.resolution.getBgSize().width / layout.width));

        const mapBox = cc.rectAddPadding(this.mapControl.getBoundingBox(), this.styles.field.padding);
        const gapTop = this.node.convertToNodeSpace(this.fieldWrapper.convertToWorldSpace(cc.p(mapBox.x, mapBox.y))).y;
        const dy = Math.max(0, (gapTop - layout.height * layout.scaleY) / 2);
        layout.setAlignment({ align: "center" }, { align: "bottom", dy });
    }

    layoutFieldWrapper() {
        const styles = this.styles;
        const mode = cleverapps.resolution.mode;
        const wrapper = this.fieldWrapper;
        const unitInfo = this.unitInfoControl;
        const button = this.switchControl;
        const ordersTablePadding = styles.ordersTable.padding[mode];
        const sceneSize = cleverapps.resolution.getSceneSize();

        this.moveControl(unitInfo, wrapper);
        this.moveControl(button, wrapper);

        this.mapControl.setScale(1);
        this.ordersTableView.setScale(1);
        unitInfo.setScale(1);
        button.setScale(1);
        this.extraBarControl && this.extraBarControl.setScale(1);

        const leftWidth = Math.max(styles.ordersTable.tableStyles.size[mode].width, unitInfo.width);
        const rightWidth = Math.max(this.extraBarView && this.extraBarView.innerContent.width || 0, button.width);
        const columnsPadding = styles.fieldWrapper.columnsPadding;
        const fieldWidth = this.mapControl.width + styles.field.padding.left + styles.field.padding.right;
        const fieldHeight = this.mapControl.height + styles.field.padding.top + styles.field.padding.bottom;

        wrapper.setContentSize(leftWidth + columnsPadding + fieldWidth + columnsPadding + rightWidth, fieldHeight);

        const sceneMargin = styles.fieldWrapper.sceneMargin[mode];
        const availableHeight = sceneSize.height - sceneMargin.top - sceneMargin.bottom;
        wrapper.setScale(Math.min(1, sceneSize.width / wrapper.width, availableHeight / wrapper.height));
        wrapper.setAlignment(sceneSize.width / 2, sceneMargin.bottom + availableHeight / 2);

        const leftX = leftWidth / 2;
        const rightX = leftWidth + columnsPadding + fieldWidth + columnsPadding + rightWidth / 2;

        this.mapControl.setAlignment(leftWidth + columnsPadding + fieldWidth / 2, { align: "bottom", dy: styles.field.padding.bottom });

        unitInfo.setAlignment(leftX, styles.unitInfo.position[mode].y);

        const infoBox = unitInfo.getBoundingBox();
        const ordersTop = wrapper.height - styles.field.padding.top;
        const ordersBottom = infoBox.y + infoBox.height + (ordersTablePadding.y || 0);
        this.ordersTableView.setContentSize(styles.ordersTable.tableStyles.size[mode].width + ordersTablePadding.x * 2, Math.max(0, ordersTop - ordersBottom));
        this.ordersTableView.updateInnerContent();

        this.ordersTableView.scrollTo(cleverapps.UI.ScrollView.SCROLLS.UPPER_LEFT);
        this.ordersTableViewControl.setAlignment(leftX, ordersBottom + this.ordersTableView.height / 2);

        let buttonX = rightX;
        if (this.extraBarView) {
            const iconsLeft = rightX - this.extraBarView.innerContent.width / 2;
            buttonX = iconsLeft + button.width * button.anchorX;
        }
        button.setAlignment(buttonX, styles.switchButton.y);

        if (this.extraBarControl) {
            const switchTop = styles.switchButton.y.dy + button.height;
            const extraBarTop = wrapper.height - styles.field.padding.top;
            this.extraBarView.setContentSize2(styles.extraBar.size[mode].width, Math.max(0, extraBarTop - switchTop));
            this.extraBarView.updateInnerContent();
            this.extraBarView.scrollToDefault();
            this.extraBarControl.setAlignment(rightX, styles.extraBar.position[mode].y);
        }

        this.updateFieldViews();
    }

    updateFieldViews() {
        this.ordersTableHiding.onResize();
        this.extraBarHiding && this.extraBarHiding.onResize();
        this.scrollLines.forEach((line) => {
            line.setScale(this.ordersTableView.getScale() * line.baseScale);
        });
    }

    setSideBarHiddenByDefault(scenes) {
        const sideBar = ComponentUtils.findComponentByName(this.node, "SideBarController");

        if (sideBar) {
            sideBar.setHiddenByDefault(scenes);
        }
    }

    updateRoomBorders() {
        if (cleverapps.config.name !== "garden") {
            return;
        }

        const bgSize = cleverapps.resolution.getBgSize();

        let topBorder = 0;
        let bottomBorder = 0;
        if (cleverapps.resolution.isVertical() && this.game.mode === Merge2.MODE_META) {
            topBorder = 0.155 * bgSize.height;
            bottomBorder = 0.083 * bgSize.height + cleverapps.resolution.getSafePadding().bottom;
        }

        this.roomView.setBorders(topBorder, bottomBorder);
    }

    onPlayIntro(f, silent) {
        let actions = this.game.listIntroActions();

        if (silent) {
            actions = actions.map((action) => function (f) {
                action(f, silent);
            });
        }

        this.game.introPlaying = true;

        cleverapps.focusManager.compound(() => {
            this.game.introPlaying = false;
            f();
        }, actions);

        return true;
    }

    listBundles() {
        const location = cleverapps.meta.getSelectedLocation();

        const result = ["game"];

        if (this.styles.gameBackground) {
            result.push("game_background_horizontal");
            result.push("game_background_vertical");
        }

        result.push(location.locationConfig.locationBundleId);
        result.push("units_main");
        result.push(`quests_${bundles[location.locationConfig.locationBundleId].meta.units}`);
        result.push(`unitstories_${location.locationId}`);
        result.push(...location.listBundles());
        result.push("tile_shop");

        return result;
    }

    getAudioStyles() {
        return {
            res: Merge2.current && Merge2.current.mode === Merge2.MODE_META && bundles.game.urls.background_music_meta
                ? bundles.game.urls.background_music_meta : bundles.game.urls.background_music_game,
            delay: 1.4,
            fadeIn: 1
        };
    }

    onAfterResize() {
        if (this.resolutionMode !== cleverapps.resolution.mode && !this.game.stopped) {
            if (this.ordersTableView) {
                this.ordersTableView.updateVisibility();
            }

            cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
            this.ordersTable.stop();
        }

        this.scrollLines.forEach((line) => line.setVisible(
            !(cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL)
            && this.ordersTableHiding.isShown
        ));

        this.resolutionMode = cleverapps.resolution.mode;
    }

    onResize() {
        const direction = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL
            ? cleverapps.UI.HORIZONTAL : cleverapps.UI.VERTICAL;

        if (this.extraBarView) {
            this.extraBarView.smallContentDocker.dockToEnd = direction === cleverapps.UI.HORIZONTAL;
            this.extraBarTable.setDirection(direction);
        }

        const styles = this.styles;
        const mode = cleverapps.resolution.mode;

        this.updateExtraBar();

        this.ordersTable.setDirection(cleverapps.resolution.isVertical() ? cleverapps.UI.HORIZONTAL : cleverapps.UI.VERTICAL);

        if (cleverapps.resolution.isVertical()) {
            const ordersTablePadding = styles.ordersTable.padding[mode];
            const sceneSize = cleverapps.resolution.getSceneSize();
            const wrapper = this.fieldWrapper;

            wrapper.setScale(1);
            wrapper.setContentSize(sceneSize);
            wrapper.setAlignment(sceneSize.width / 2, sceneSize.height / 2);

            const fieldScale = styles.field.verticalScale;
            const availableWidth = cleverapps.resolution.getBgSize().width - 2 * styles.field.verticalPadding;
            const mapWidth = this.mapControl.width * fieldScale;
            this.mapControl.setScale(mapWidth > availableWidth ? fieldScale * availableWidth / mapWidth : fieldScale);
            this.mapControl.setAlignment(styles.field.verticalPosition);
            const mapBox = cc.rectAddPadding(this.mapControl.getBoundingBox(), styles.field.padding);

            this.ordersTableView.setScale(1);
            this.ordersTableView.setContentSize(
                cleverapps.resolution.getBgSize().width,
                styles.ordersTable.tableStyles.size[mode].height + 2 * ordersTablePadding.y
            );
            this.ordersTableView.updateInnerContent();
            const yPos = mapBox.y + mapBox.height + styles.ordersTable.verticalOffset + this.ordersTableView.height / 2;
            this.ordersTableViewControl.setAlignment(wrapper.width / 2, yPos - ordersTablePadding.y);

            if (this.extraBarControl) {
                this.extraBarView.setContentSize2(styles.extraBar.size);
                this.extraBarView.updateInnerContent();
                this.extraBarView.scrollToDefault();
                this.extraBarControl.setScale(0.48);
                this.extraBarControl.setAlignment(styles.extraBar.position);
            }

            this.updateFieldViews();
        }

        this.updateLayout();
        this.gameBackground && this.updateBackground();

        const bgSize = cleverapps.resolution.getBgSize();
        this.roomView.setAlignment(this.node.convertToNodeSpace(cc.p(bgSize.width / 2, bgSize.height / 2)));
        this.updateRoomBorders();
    }

    updateBackground() {
        const newFrame = this.getBackgroundFrame();
        if (this.currentBackgroundFrame !== newFrame) {
            this.currentBackgroundFrame = newFrame;
            this.gameBackground.removeFromParent();
            this.gameBackground = new cc.Sprite(newFrame);
            this.gameBackground.setLocalZOrder(-10);
            this.node.addChild(this.gameBackground);
        }

        const screenSize = cleverapps.resolution.getBgSize();
        const visibleBottom = -this.node.y;
        const visibleTop = visibleBottom + screenSize.height;

        const contentSize = this.gameBackground.getContentSize();
        const scaleX = screenSize.width / contentSize.width;

        const anchorY = this.styles.gameBackground.anchorY[cleverapps.resolution.mode];

        if (anchorY === null || anchorY === undefined) {
            this.gameBackground.setAnchorPoint(0.5, 0.5);
            this.gameBackground.setScale(Math.max(scaleX, screenSize.height / contentSize.height));
            this.gameBackground.setPosition(this.node.width / 2, visibleBottom + screenSize.height / 2);
            return;
        }

        let anchor;
        if (cleverapps.resolution.isVertical()) {
            const content = this.ordersTableView.innerContent;
            const contentBox = content.getBoundingBox();
            anchor = this.node.convertToNodeSpace(content.getParent().convertToWorldSpace(cc.p(contentBox.x, contentBox.y)));
        } else {
            const mapBox = this.mapControl.getBoundingBox();
            anchor = this.node.convertToNodeSpace(this.fieldWrapper.convertToWorldSpace(cc.p(mapBox.x, mapBox.y + mapBox.height)));
        }

        this.gameBackground.setAnchorPoint(0.5, anchorY);
        const posX = this.node.width / 2;
        const posY = anchor.y;

        const scaleY = Math.max((posY - visibleBottom) / (anchorY * contentSize.height), (visibleTop - posY) / ((1 - anchorY) * contentSize.height));
        this.gameBackground.setScale(Math.max(scaleX, scaleY));

        this.gameBackground.setPosition(posX, posY);
    }

    getBackgroundFrame() {
        const isVertical = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL;

        const bgBundle = isVertical ? "game_background_vertical" : "game_background_horizontal";
        return bundles[bgBundle].urls.background;
    }

    updateExtraBar() {
        if (!Merge2.current) {
            return;
        }

        if (this.game.generatorMultiplier.isAvailable()) {
            cleverapps.extraBar.addIcon(this.game.generatorMultiplier);
        }

        if (cleverapps.energyBooster.isActive()) {
            cleverapps.extraBar.addIcon(EnergyBoosterExtraBarIcon);
        }

        if (cleverapps.resolution.isVertical()) {
            cleverapps.extraBar.removeIcon(this.game.bubblesStack);

            if (cleverapps.weeklyGoals.isAvailable()) {
                cleverapps.extraBar.removeIcon(WeeklyGoalsExtraBarIcon, true);
            }

            if (cleverapps.raveReviews.isAvailable()) {
                cleverapps.extraBar.addIcon(cleverapps.raveReviews);
            }

            cleverapps.extraBar.removeIcon(this.game.backpack);
            this.backpackControl.setVisible(true);
        } else {
            cleverapps.extraBar.addIcon(this.game.bubblesStack);

            if (cleverapps.weeklyGoals.isAvailable()) {
                cleverapps.extraBar.addIcon(WeeklyGoalsExtraBarIcon);
            }

            cleverapps.extraBar.removeIcon(cleverapps.raveReviews, true);

            cleverapps.extraBar.addIcon(this.game.backpack);

            this.backpackControl.setVisible(false);
        }

        cleverapps.eventBus.trigger("updateExtraBar");
    }

    animateZoom(zoom, duration, f) {
        f();
    }

    showHint(view, message) {
        const styles = this.styles.hint;

        const text = cleverapps.UI.generateOnlyText(message, styles.font);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setWrapWidth(styles.width);
        text.fitTo(styles.width, styles.height);
        text.setAlignment(styles);
        view.addChild(text);

        text.replaceParentSamePlace(this.node.movingNode);
        text._setGlobalZOrder(true);

        const targetRect = text.getBoundingBox();
        const clampedRect = cc.rectClampToRect(targetRect, cc.rect(0, 0, this.node.width, this.node.height));
        text.setAlignment(text.x + (clampedRect.x - targetRect.x), text.y + (clampedRect.y - targetRect.y));

        text.setScaleY(0);
        text.runAction(new cc.Sequence(
            new cc.Spawn(
                new cc.ScaleTo(0.5, 1, 1).easing(cc.easeBackOut(2)),
                new cc.FadeOut(2).easing(cc.easeIn(2)),
                new cc.MoveBy(1, 0, 50).easing(cc.easeElasticOut(0.5))
            ),
            new cc.CallFunc(() => text.removeFromParent())
        ));
    }

    onDestruct() {
        if (this.gameplayStarted) {
            connector.platform.gameplayStop(cleverapps.gameLevel.getLevel());
        }

        this.extraBarTable.destructor();

        if (Merge2.current) {
            Merge2.current.stop();
            Merge2.current = undefined;
        }
    }
}

Prefab.registerComponent("Merge2SceneComponent", Merge2SceneComponent);

GameScene = bundles.main.jsons.merge2scene_prefab_json;
